import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

export const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easeOut } },
};

export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

// Scroll-reveal wrapper
export function Reveal({ children, className, delay = 0, y = 28, as = "div" }) {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.65, ease: easeOut, delay }}
        >
            {children}
        </MotionTag>
    );
}
